"use client";

import { useEffect, useState } from "react";
import {
  APP_DOWNLOAD_PROMPT_MAX_DISMISSALS,
  useAppDownloadPromptStore,
} from "@/store/appDownloadPrompt";

// Tracked per device in localStorage; the web app can't tell whether the mobile app is installed.
export function useAppDownloadPrompt() {
  const [open, setOpen] = useState(false);

  // Read after mount so SSR and first client render agree.
  useEffect(() => {
    const { dismissCount } = useAppDownloadPromptStore.getState();
    setOpen(dismissCount < APP_DOWNLOAD_PROMPT_MAX_DISMISSALS);
  }, []);

  const onOpenChange = (next: boolean) => {
    if (!next && open) {
      try {
        useAppDownloadPromptStore.getState().recordDismissal();
      } catch {
        // Storage can throw (quota, private mode); the count is lost but the prompt must still close.
      }
    }
    setOpen(next);
  };

  return { open, onOpenChange };
}
